module.exports = __webpack_public_path__ + "img/kwanza.24d4784.svg";